import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { toast } from '../hooks/use-toast';
import { companyInfo, services, frameworks, caseStudy, aboutInfo } from '../mock';
import { HeroSection } from '../components/home/HeroSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { FrameworksSection } from '../components/home/FrameworksSection';
import { CaseStudySection } from '../components/home/CaseStudySection';
import { AboutSection } from '../components/home/AboutSection';
import { ContactSection } from '../components/home/ContactSection';
import { Footer } from '../components/home/Footer';

const API = '/api';

const Home = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', company: '', phone: '', message: ''
  });

  const handleInputChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API}/consultations`, formData);
      if (response.data.success) {
        toast({ title: "Consultation Request Received", description: "We'll get back to you within 24 hours." });
        setFormData({ name: '', email: '', company: '', phone: '', message: '' });
      }
    } catch (error) {
      let errorMessage = "Please try again later.";
      const detail = error.response?.data?.detail;
      if (typeof detail === 'string') {
        errorMessage = detail;
      } else if (Array.isArray(detail)) {
        errorMessage = detail.map(err => err.msg || JSON.stringify(err)).join(', ');
      }
      toast({ title: "Submission Failed", description: errorMessage, variant: "destructive" });
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <nav className="hidden md:flex space-x-8">
              <a href="#services" className="text-slate-700 hover:text-[#105EFF] transition-colors">Services</a>
              <a href="#frameworks" className="text-slate-700 hover:text-[#105EFF] transition-colors">Frameworks</a>
              <a href="#case-study" className="text-slate-700 hover:text-[#105EFF] transition-colors">Case Study</a>
              <a href="#about" className="text-slate-700 hover:text-[#105EFF] transition-colors">About</a>
              <a href="#contact" className="text-slate-700 hover:text-[#105EFF] transition-colors">Contact</a>
            </nav>
            <Button asChild className="bg-[#105EFF] hover:bg-[#0D4FCC] text-white ml-auto font-bold">
              <a href="#contact">Schedule a free consultation</a>
            </Button>
          </div>
        </div>
      </header>

      <HeroSection companyInfo={companyInfo} />
      <ServicesSection services={services} />
      <FrameworksSection frameworks={frameworks} />
      <CaseStudySection caseStudy={caseStudy} />
      <AboutSection aboutInfo={aboutInfo} />
      <ContactSection companyInfo={companyInfo} formData={formData} onInputChange={handleInputChange} onSubmit={handleSubmit} />
      <Footer companyInfo={companyInfo} />
    </div>
  );
};

export default Home;
